import { render } from "./NewTaskDialog.vue?vue&type=template&id=7843996c&scoped=true"
import script from "./NewTaskDialog.vue?vue&type=script&lang=js"
export * from "./NewTaskDialog.vue?vue&type=script&lang=js"

import "./NewTaskDialog.vue?vue&type=style&index=0&id=7843996c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7843996c"]])

export default __exports__